import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';

export type AllowedEntryLanguagesType = string[];

export async function getAllowedEntryLanguagesFromApi(): Promise<AllowedEntryLanguagesType> {
	// const response = await apiGetSettingKey.callApi();
	// return response.map((x) => x.recipeSettings.entryLanguages).getOrDefault([]);
	return [];
}

const rb = new ReducerBuilder<AllowedEntryLanguagesType>();

export const allowedEntryLanguagesLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'allowedEntryLanguages/LoadedFromBackend'
);

export const allowedEntryLanguagesReducer = rb.createReducer();
